import React from "react";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { shape, string } from "prop-types";
import defaultClasses from "./socialIcon.css";
var SocialIcon = props => {
  var {
    type,
    icon
  } = props;
  if (!type) {
    return null;
  }
  var classes = mergeClasses(defaultClasses, props.classes);
  var style = {
    "--amslBtnBg": "var(--amsl-".concat(type, "-button__background)")
  };
  return /*#__PURE__*/React.createElement("span", {
    style: style,
    className: "".concat(classes.root)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      backgroundImage: "url(".concat(icon, ")")
    },
    className: classes.icon
  }));
};
SocialIcon.propTypes = {
  classes: shape({
    root: string
  }),
  type: string
};
export default SocialIcon;